module.exports = [
  { label: "DXY", ticker: "DXY", pipDistance: 0.001, session: 0 },

  { label: "Forex", ticker: "", pipDistance: 0, multiplier: 0, session: 0 },

  {
    label: "AUD/CAD",
    ticker: "AUDCAD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "AUD_CAD",
    session: "07:00-16:00",
    sessionTimezone: "Australia/Sydney",
  },
  {
    label: "AUD/CHF",
    ticker: "AUDCHF",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "AUD_CHF",
    session: "07:00-16:00",
    sessionTimezone: "Australia/Sydney",
  },
  {
    label: "AUD/JPY",
    ticker: "AUDJPY",
    pipDistance: 0.01,
    multiplier: 1,
    oanda: "AUD_JPY",
    session: "07:00-16:00",
    sessionTimezone: "Australia/Sydney",
  },
  {
    label: "AUD/NZD",
    ticker: "AUDNZD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "AUD_NZD",
    session: "07:00-16:00",
    sessionTimezone: "Australia/Sydney",
  },
  {
    label: "AUD/USD",
    ticker: "AUDUSD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "AUD_USD",
    session: "07:00-16:00",
    sessionTimezone: "Australia/Sydney",
  },
  {
    label: "CAD/JPY",
    ticker: "CADJPY",
    pipDistance: 0.01,
    multiplier: 1,
    oanda: "CAD_JPY",
    session: "13:30-16:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "CAD/CHF",
    ticker: "CADCHF",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "CAD_CHF",
    session: "08:00-16:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "CHF/JPY",
    ticker: "CHFJPY",
    pipDistance: 0.01,
    multiplier: 1,
    oanda: "CHF_JPY",
    session: "08:00-10:00",
    sessionTimezone: "Europe/Zurich",
  },
  {
    label: "GBP/AUD",
    ticker: "GBPAUD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "GBP_AUD",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "GBP/CAD",
    ticker: "GBPCAD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "GBP_CAD",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "GBP/CHF",
    ticker: "GBPCHF",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "GBP_CHF",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "GBP/JPY",
    ticker: "GBPJPY",
    pipDistance: 0.01,
    multiplier: 1,
    oanda: "GBP_JPY",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "GBP/NZD",
    ticker: "GBPNZD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "GBP_NZD",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "GBP/USD",
    ticker: "GBPUSD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "GBP_USD",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "EUR/USD",
    ticker: "EURUSD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "EUR_USD",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "EUR/AUD",
    ticker: "EURAUD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "EUR_AUD",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "EUR/CAD",
    ticker: "EURCAD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "EUR_CAD",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "EUR/GBP",
    ticker: "EURGBP",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "EUR_GBP",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "EUR/JPY",
    ticker: "EURJPY",
    pipDistance: 0.01,
    multiplier: 1,
    oanda: "EUR_JPY",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "EUR/CHF",
    ticker: "EURCHF",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "EUR_CHF",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "EUR/NZD",
    ticker: "EURNZD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "EUR_NZD",
    session: "08:00-12:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "NZD/CAD",
    ticker: "NZDCAD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "NZD_CAD",
    session: "07:00-16:00",
    sessionTimezone: "Pacific/Auckland",
  },
  {
    label: "NZD/CHF",
    ticker: "NZDCHF",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "NZD_CHF",
    session: "07:00-16:00",
    sessionTimezone: "Pacific/Auckland",
  },
  {
    label: "NZD/JPY",
    ticker: "NZDJPY",
    pipDistance: 0.01,
    multiplier: 1,
    oanda: "NZD_JPY",
    session: "07:00-16:00",
    sessionTimezone: "Pacific/Auckland",
  },
  {
    label: "NZD/USD",
    ticker: "NZDUSD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "NZD_USD",
    session: "07:00-16:00",
    sessionTimezone: "Pacific/Auckland",
  },
  {
    label: "USD/CHF",
    ticker: "USDCHF",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "USD_CHF",
    session: "08:00-16:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "USD/JPY",
    ticker: "USDJPY",
    pipDistance: 0.01,
    multiplier: 1,
    oanda: "USD_JPY",
    session: "08:00-16:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "USD/CAD",
    ticker: "USDCAD",
    pipDistance: 0.0001,
    multiplier: 1,
    oanda: "USD_CAD",
    session: "08:00-16:00",
    sessionTimezone: "America/New_York",
  },

  { label: "Indices", ticker: "", pipDistance: 0, multiplier: 0, session: 0 },

  {
    label: "AUS200",
    ticker: "AUS200",
    pipDistance: 0.1,
    multiplier: 10,
    baseCurrency: "AUD",
    session: "00:00-09:00",
  },
  {
    label: "S&P 500",
    ticker: "SPX500",
    pipDistance: 0.1,
    multiplier: 10,
    baseCurrency: "USD",
    session: "09:30-16:00",
    sessionTimezone: "America/New_York",
  },
  {
    label: "JP225",
    ticker: "JPN225",
    pipDistance: 0.1,
    multiplier: 10,
    baseCurrency: "JPY",
    session: "00:00-06:00",
  },
  // {
  //   label: "CHN50",
  //   ticker: "CHN50",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "USD",
  //   session: "01:30-08:30",
  // },
  // {
  //   label: "ESP35",
  //   ticker: "ESP35",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "EUR",
  //   session: "08:00-17:00",
  // },
  // {
  //   label: "EUSTX50",
  //   ticker: "EUSTX50",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "EUR",
  //   session: "08:00-17:00",
  // },
  // {
  //   label: "FRA40",
  //   ticker: "FRA40",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "EUR",
  //   session: "08:00-17:00",
  // },
  // {
  //   label: "GER30",
  //   ticker: "GER30",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "EUR",
  //   session: "08:00-17:00",
  // },
  // {
  //   label: "HKG33",
  //   ticker: "HKG33",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "HKD",
  //   session: "01:30-08:00",
  // },

  // {
  //   label: "NAS100",
  //   ticker: "NAS100",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "USD",
  //   session: "09:30-16:00",
  //   sessionTimezone: "America/New_York",
  // },

  // {
  //   label: "UK100",
  //   ticker: "UK100",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "GBP",
  //   session: "08:00-16:30",
  //   sessionTimezone: "Europe/London",
  // },
  // {
  //   label: "US2000",
  //   ticker: "US2000",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "USD",
  //   session: "09:30-16:00",
  //   sessionTimezone: "America/New_York",
  // },
  // {
  //   label: "US30",
  //   ticker: "US30",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   baseCurrency: "USD",
  //   session: "09:30-16:00",
  //   sessionTimezone: "America/New_York",
  // },

  {
    label: "Commodities",
    ticker: "",
    pipDistance: 0,
    multiplier: 0,
    session: 0,
  },

  // {
  //   label: "COFFEE",
  //   ticker: "COFFEENYF",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   commoditie: true,
  //   session: "14:00-20:00",
  // },
  // {
  //   label: "COPPER",
  //   ticker: "COPPER",
  //   pipDistance: 0.1,
  //   multiplier: 1000,
  //   commoditie: true,
  //   session: "00:30-18:00",
  // },
  // {
  //   label: "CORN",
  //   ticker: "CORNF",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   commoditie: true,
  //   session: "12:00-19:00",
  // },
  {
    label: "XAU/USD",
    ticker: "XAUUSD",
    pipDistance: 0.1,
    multiplier: 10,
    commoditie: true,
    session: "00:00-23:00",
  },
  // {
  //   label: "NGAS",
  //   ticker: "NGAS",
  //   pipDistance: 0.1,
  //   multiplier: 1000,
  //   commoditie: true,
  //   session: "00:30-21:00",
  // },
  // {
  //   label: "WHEAT",
  //   ticker: "WHEATF",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   commoditie: true,
  //   session: "12:00-19:00",
  // },
  {
    label: "XAG/USD",
    ticker: "XAGUSD",
    pipDistance: 0.1,
    multiplier: 100,
    commoditie: true,
    session: "00:00-23:00",
  },
  // {
  //   label: "SOY",
  //   ticker: "SOYF",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   commoditie: true,
  //   session: "12:00-19:00",
  // },
  // {
  //   label: "SUGAR",
  //   ticker: "SUGARNYF",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   commoditie: true,
  //   session: "14:00-20:00",
  // },
  // {
  //   label: "UKOIL",
  //   ticker: "UKOIL",
  //   pipDistance: 0.1,
  //   multiplier: 100,
  //   commoditie: true,
  //   session: "01:00-22:00",
  // },
  // {
  //   label: "USOIL",
  //   ticker: "USOIL",
  //   pipDistance: 0.1,
  //   multiplier: 100,
  //   commoditie: true,
  //   session: "00:00-23:00",
  // },

  { label: "Crypto", ticker: "", pipDistance: 0, multiplier: 0, session: 0 },

  {
    label: "BTC/USD",
    ticker: "BTCUSD",
    pipDistance: 0.1,
    multiplier: 10,
    crypto: true,
    session: "00:00-23:59",
  },
  // {
  //   label: "ETH/USD",
  //   ticker: "ETHUSD",
  //   pipDistance: 0.1,
  //   multiplier: 10,
  //   crypto: true,
  //   session: "00:00-23:59",
  // },
];
